import React from "react";
import {    
    FormTab,
    Tab,
    ReferenceField,
    TextField,
    choices,
    useResourceContext,
} from "react-admin";
import { Box, Typography, Divider, Chip} from '@mui/material';
import { HECOSCodesShow, HECOSCodesInput, PrsbAccreditations } from "../../../lib/CommonComponents";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}

export const ModuleAdditionalInfoInputTab = (props) =>{
    const resource = useResourceContext();
    return <FormTab {...props} label="myroot.moduleAdditionalInfo">        
        <Box display="flex" width={1}>
            <Box flex={4}>
                <Typography variant="h6" style={titleStyle} sx={{ marginBottom: '15px' }}>
                    Module | <small><TextField source="id" label={false} /></small> | <small><TextField source="shortTitle" label={false} /></small>
                </Typography>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="HECoS Codes" /></b></Divider>
            </Box>
        </Box>
        <Box display='flex' width={1}>        
            <Box flex={2}>
                <HECOSCodesInput {...props} />
            </Box>
            <Box flex={2}>
                
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="PSRB Accreditations" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
           <PrsbAccreditations />
        </Box>  
        {resource === "Module" &&
            <VersioningTypeInput source="versioningType" resource={resource} />
        }
    </FormTab>
    
}
    

export const ModuleAdditionalInfoShowTab = (props) => 
    <Tab {...props} label="myroot.moduleAdditionalInfo">
        <ReferenceField source="jacsCodeId" label="myroot.ascCode" reference="JacsCode" linkType="show" >
            <ReferenceField source="asccode_id" reference="AscCode" >
                <TextField source="description" />
            </ReferenceField>
        </ReferenceField>       
        <HECOSCodesShow {...props} /> 
    </Tab> 


const validateValidation = choices(['validated', 'modified', 'corrected'], 'Please check the forms mandatory fields are complete');
